import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const MockHandlePaymentPage = () => {
    throw new Error('handlePaymentPage not implemented');
};
const PageBuilderContext = React.createContext({
    handlePaymentPage: MockHandlePaymentPage,
});
const PageBuilderProvider = ({ children, handlePaymentPage }) => {
    return (_jsx(PageBuilderContext.Provider, { value: { handlePaymentPage: handlePaymentPage !== null && handlePaymentPage !== void 0 ? handlePaymentPage : MockHandlePaymentPage }, children: children }));
};
export default PageBuilderProvider;
export const usePageBuilder = () => React.useContext(PageBuilderContext);
